// Core
import styled from 'styled-components';

// Config
import { BREAKPOINTS } from '../../../../../../config/screen';

export const VibrationItemsContainer = styled.ul`
  width: 100%;
  margin: 0;
  padding: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const VibrationTagContainer = styled.div`
  padding-top: 1px;
`;

export const VibrationItem = styled.li<{ hasOnlyOneSensor?: boolean }>`
  display: flex;
  background-color: ${({ theme }) => theme.color.crusherDashboard.modulesBackgroundColor};
  flex-direction: column;
  padding: 0 1.5rem;
  min-height: 34px;
  justify-content: center;
  width: 100%;
  border-top: 1px solid ${({
    theme,
  }) => theme.color.crusherDashboard.vibrationModule.itemsBorderColor};
  list-style: none;
  flex: 1;
  margin-top: 1px;

  @media (min-width: ${BREAKPOINTS.xs}px) and (max-width: ${BREAKPOINTS.sm}px) {
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 2px;
    padding-bottom: 2px;
  };

  @media (min-width: ${BREAKPOINTS.sm}px) and (max-width: ${BREAKPOINTS.lg}px) {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    padding-top: 2px;
    padding-bottom: 2px;
  };

  @media (min-width: ${BREAKPOINTS.lg}px) {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    padding-top: 2px;
    padding-bottom: 2px;
  };
`;

export const VibrationContainer = styled.div`
  background-color: ${({ theme }) => theme.color.crusherDashboard.modulesBackgroundColor};
  max-height: 25%;
  height: max-content;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
`;
